import { type FC } from "react";
import { Button, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Filter, FilterProvider } from "@/partner/shared/components/Filter";
import { PollsLibraryList } from "./PollsLibraryList";
import { PollLibraryDialog } from "./PollLibraryDialog";

/**
 * Библиотека опросов (спека, «Переделка: опросы как виджеты»): страница в
 * стиле виджетов, поиск внутри панели фильтра, диалоги по URL
 * (?tab=create, ?tab=edit&id=), чтобы на них можно было дать ссылку.
 */
const PollsLibraryInner: FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const editId = searchParams.get("id");

  const openCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const openEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const closeDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <>
      <Stack spacing={1}>
        <Filter
          title={t("pollsLibrary.list.title")}
          action={
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              disableElevation
              onClick={openCreate}
            >
              {t("common.actions.add")}
            </Button>
          }
          fields={{ search: true }}
        />
        <PollsLibraryList onClickRow={(poll) => openEdit(poll.id)} />
      </Stack>
      {tab === "create" && (
        <PollLibraryDialog pollId={null} onClose={closeDialog} />
      )}
      {tab === "edit" && editId && (
        <PollLibraryDialog pollId={editId} onClose={closeDialog} />
      )}
    </>
  );
};

export const PollsLibrary: FC = () => (
  <FilterProvider>
    <PollsLibraryInner />
  </FilterProvider>
);
